import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import SidePanel from '../../components/filters/SidePanel';
import CustomSelect from '../../components/forms/Select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faChartLine } from '@fortawesome/pro-light-svg-icons';
import Button from '../../components/buttons/Button';
import Tooltip from '../../components/tooltip/Tooltip';
import Legend from '../../components/forms/Legend';
import EditInPlace from '../../components/forms/EditInPlace';

const AlarmsSidePanelWrapper = styled.div`
  height: 100%;

  .sidepanel {
    &__section {
      border-top: 1px solid ${getTheme('black', '_800')};
      padding-top: ${getTheme('marginBottom', 'm')};
      margin-bottom: ${getTheme('marginBottom', 'm')};
      padding-left: ${getTheme('padding', 'horizontalL')};
      padding-right: ${getTheme('padding', 'horizontalL')};
      margin-left: -${getTheme('padding', 'horizontalL')};
      margin-right: -${getTheme('padding', 'horizontalL')};
      > :last-child {
        margin-bottom: 0;
      }
    }
  }
  .variable-group {
    &:not(:last-child) {
      border-bottom: 1px solid ${getTheme('black', '_800')};
      padding-bottom: ${getTheme('padding', 'verticalL')};
      margin-bottom: ${getTheme('padding', 'verticalL')};
    }
    &__title {
      font-size: ${getTheme('fontSize', 'note')};
      font-weight: 600;
      margin-bottom: ${getTheme('spacer', 's')};
    }
    &__variable {
      font-size: ${getTheme('fontSize', 'caption')};
      display: flex;
      align-items: center;
      margin-bottom: ${getTheme('spacer', 'xs')};
    }
    &__variable-text {
      display: block;
      white-space: nowrap;
      max-width: 16em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__remove {
      border: 0;
      padding: 0;
      margin-left: ${getTheme('spacer', 'm')};
      color: ${getTheme('textColor', 'baseLight')};
      font-size: ${getTheme('fontSize', 'note')};
      background-color: transparent;
      cursor: pointer;
    }
  }

  .novars {
    display: flex;
    align-items: center;
    font-weight: 300;
    line-height: 1.2;
    color: ${getTheme('textColor', 'altLight')};
    &__icon {
      color: ${getTheme('textColor', 'baseLight')};
      font-size: ${getTheme('fontSize', 'display')};
      margin-right: ${getTheme('spacer', 'm')};
    }
  }

  .hide {
    display: none;
  }
`;

class AlarmsSidePanel extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      varGroups: [],
      groupName: '',
      group: {},
      groupVars: [],
      selectedVars: [],
      refreshCharts: 0,
    };
    this.selectGroup = this.selectGroup.bind(this);
    this.selectVar = this.selectVar.bind(this);
    this.removeVar = this.removeVar.bind(this);
    this.changeChartName = this.changeChartName.bind(this);
  }

  changeChartName(evt) {
    this.props.updateChartName(this.props.panelChart.id, evt.target.value);
  }

  selectGroup(group) {
    let groupSelectedVariables = this.state.selectedVars.filter(obj => {
      return obj.groupName === group.label;
    });

    let remainingGroupVariables = group.variables.slice();

    groupSelectedVariables.forEach(elm => {
      remainingGroupVariables = remainingGroupVariables.filter(obj => {
        return obj.value !== elm.value;
      });
    });

    this.setState({
      group: group,
      groupName: group.label,
      groupVars: remainingGroupVariables,
    });
  }
  selectVar(v) {
    const currentGroup = this.state.groupName;
    const varsWithId = v.map(x => {
      x.varId = currentGroup + '::' + x.value;
      x.groupName = currentGroup;
      return x;
    });
    let updatedSelectedVars = this.state.selectedVars.map(x => x);
    updatedSelectedVars = updatedSelectedVars.concat(varsWithId);
    updatedSelectedVars = updatedSelectedVars.filter(
      (s1, pos, arr) => arr.findIndex(s2 => s2.varId === s1.varId) === pos,
    );
    this.setState({
      selectedVars: updatedSelectedVars,
    });
  }

  removeVar(varId) {
    const $this = this;
    let updatedSelectedVars = this.state.selectedVars;
    updatedSelectedVars = updatedSelectedVars.filter(function(obj) {
      return obj.varId !== varId;
    });
    this.setState({
      selectedVars: updatedSelectedVars,
    });
    this.props.handleUpdate(
      this.props.panelChart.id,
      updatedSelectedVars,
      'remove',
      varId,
      function() {
        if ($this.state.group.value) {
          $this.selectGroup($this.state.group);
        }
      },
    );
  }

  componentDidMount() {
    let data_variables_lists = this.props.data_variables_lists;
    if (!data_variables_lists) {
      return '';
    }
    this.setState({
      varGroups: data_variables_lists,
      groupVars: [],
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.panelChart !== this.props.panelChart) {
      this.setState({
        selectedVars: newProps.panelChart.vars,
      });
    }
  }

  render() {
    let isSelectDisabled;
    if (this.state.groupVars.length === 0) {
      isSelectDisabled = true;
    } else {
      isSelectDisabled = false;
    }

    let alreadySelectedVars;
    if (this.props.panelChart.vars) {
      let rawVars = this.props.panelChart.vars;
      let orderedVars = [];

      function extactVars() {
        if (!rawVars.length) {
          return;
        }
        let extractedVars = rawVars.filter(function(obj) {
          return obj.groupName === rawVars[0].groupName;
        });
        orderedVars.push(extractedVars);
        rawVars = rawVars.filter(function(obj) {
          return obj.groupName !== rawVars[0].groupName;
        });
        extactVars();
      }
      extactVars();
      alreadySelectedVars = orderedVars.map((item, key) => (
        <div className="variable-group" key={key}>
          <h6 className="variable-group__title">{item[0].groupName}</h6>
          {item.map((itemvar, key2) => {
            return (
              <div className="variable-group__variable" key={key2}>
                <span data-tip={itemvar.label} className="variable-group__variable-text">
                  {itemvar.label}
                </span>
                <button
                  className="variable-group__remove"
                  onClick={() => {
                    this.removeVar(itemvar.varId);
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            );
          })}
          <Tooltip />
        </div>
      ));
    }

    let panelChart = { id: 0 };
    if (this.props.panelChart && this.props.panelChart.id) {
      panelChart = this.props.panelChart;
    }

    return (
      <AlarmsSidePanelWrapper>
        <SidePanel
          handleClose={this.props.handleClose}
          className={this.props.className}
          panelVisibility={this.props.panelVisibility}
          panelChart={this.props.panelChart}
          panelChartHeading={
            <EditInPlace
              key={`chartheading__` + this.props.panelChart.id}
              value={this.props.panelChart.name}
              onChange={this.changeChartName}
            />
          }
        >
          {this.props.panelVisibility === true && (
            <div className="sidepanel__section">
              <Legend size="xsmall">Add variables to the chart</Legend>
              <CustomSelect
                key={`select_groupvars` + this.state.refreshCharts}
                size="xsmall"
                label="Group"
                options={this.state.varGroups}
                handleChange={element => {
                  this.selectGroup(element);
                }}
              />
              <CustomSelect
                key={`select_groupvars_variable` + this.state.groupVars + this.state.refreshCharts}
                size="xsmall"
                label="Variable"
                isMulti
                isDisabled={isSelectDisabled}
                options={this.state.groupVars}
                handleChange={element => {
                  this.selectVar(element);
                }}
              />
              <Button
                type="button"
                size="xsmall"
                className=""
                iconBefore={<FontAwesomeIcon icon={faPlus} />}
                onClick={() => {
                  let selectedVars = this.state.selectedVars;
                  this.props.handleUpdate(panelChart.id, selectedVars, 'add', '');
                  this.setState({
                    groupVars: [],
                    refreshCharts: this.state.refreshCharts + 1,
                  });
                }}
              >
                Add to chart
              </Button>
            </div>
          )}
          <div className="sidepanel__section">
            <Legend size="xsmall">Variables</Legend>
            {this.props.panelChart.vars && this.props.panelChart.vars.length === 0 && (
              <div className="novars">
                <div className="novars__icon">
                  <FontAwesomeIcon icon={faChartLine} />
                </div>
                There are no variables added&nbsp;yet
              </div>
            )}
            {alreadySelectedVars}
          </div>
        </SidePanel>
      </AlarmsSidePanelWrapper>
    );
  }
}

export default AlarmsSidePanel;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsSidePanel.js